import { useEffect } from 'react';

declare global {
  interface Window {
    __PRERENDER_READY__?: boolean;
    __PRERENDER_STATUS__?: number;
  }
}

export const SITE_ORIGIN = 'https://vendor.clareefai.com';

export function usePrerenderReady(isReady: boolean, status: number = 200): void {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.__PRERENDER_STATUS__ = status;
    if (isReady) {
      window.__PRERENDER_READY__ = true;
    }
  }, [isReady, status]);
}
